



























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { UmbrellaModel, UmbrellaType } from "@/models/products/umbrella";
import { Component, Watch, Prop } from "vue-property-decorator";
import Items from "./Items";
import RadioButtonBox from "@/components/elements/utility/RadioButtonBox.vue";
import AccordionSection from "@/components/elements/accordion/AccordionSection.vue";
import { LineItem, Note } from "@/models/order/order";
import { ProductType } from "@/models/products/product";
import * as option from "@/models/configurator/configurator_options";
import AddToQuoteFooter from "@/components/footer/AddToQuoteFooter.vue";
import ProductService from "@/services/product_service";
import { AuthError, GenericError } from "@/services/error_service";
import { FabricComponent } from "@/models/configurator/fabric_components";
import FabricSelector from "@/components/items/fabric_picker/FabricSelector.vue";
import MiniSwatch from "@/components/elements/products/MiniSwatch.vue";
import DeleteSwatch from "@/components/elements/utility/DeleteSwatch.vue";
import { CustomUmbrellaOrder } from "@/models/configurator/custom_umbrella";
import { FabricSwatch, FixedFabricArray } from "@/models/products/fabric";
import { ribAttachment, grommetOnlyModels } from "@/mixins/business_logic/rib_rules";
import { hasFinial } from "@/mixins/business_logic/finial_rules";
import { hasBottomPole } from "@/mixins/business_logic/bottompole_rules";
import { ProductLineName } from "@/models/products/collection";
import { Validations } from "vuelidate-property-decorators";
import {
  maxLength,
  minLength,
  required,
  requiredIf
} from "vuelidate/lib/validators";
import { arrayLenEven } from "@/validators/custom";
import FormValidation from "@/components/elements/form/FormValidation.vue";
import { EventBus } from "@/event-bus";
import { ConfigFile } from "@/models/configurator/config_file";
import { NoteFields } from "@/models/order/helpers";
import { FinishDisplayName, FinishHandle } from "@/models/products/finish";
import DropdownFinishes from "@/components/elements/utility/DropdownFinishes.vue";
import Dropdown from "@/components/elements/utility/Dropdown.vue";
import SpecsModal from "@/components/elements/modal/SpecsModal.vue";
import { formatTitle, getFinishImage } from "@/utility/helpers";
import { StoreModule } from "@/store/types";
import {
  GlobalActions,
  GlobalGetters
} from "@/store/modules/global/types";
import { Roles } from "@/models/user/roles";
import { PriceLevel } from "@/models/netsuite/netsuite";
import { namespace } from "vuex-class";

@Component({
  components: {
    AccordionSection,
    RadioButtonBox,
    AddToQuoteFooter,
    FabricSelector,
    MiniSwatch,
    DeleteSwatch,
    FormValidation,
    DropdownFinishes,
    Dropdown,
    SpecsModal
  }
})
export default class CustomizeUmbrella extends Items {
  @(namespace(StoreModule.Global).Action(GlobalActions.AddMultiplier))
  addMultiplier!: (value: PriceLevel | null) => Promise<void>;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetRole))
  userRole!: Roles | null;

  protected isStockOnly = true;
  protected defaultConfigFile: null | ConfigFile = null;
  /**
   * Captured from the collection at `created()` time. Used by the trim
   * dimension getters (4"/6"/2"/4") since dimensions differ between
   * Market and Cantilever umbrellas. Mirrors shade-designer's
   * isMarketType pattern.
   */
  protected umbrellaType: UmbrellaType | null = null;
  /**
   * Cached WHP swatch — used as the default for valance binding and
   * the first fringe fabric. Fetched once at `created()` time so we
   * don't re-hit the API on every valance/fringe toggle.
   */
  protected whpFabric: FabricSwatch | null = null;
  protected whpPromise: Promise<FabricSwatch> | null = null;
  /**
   * Cached weight-keyed white fabric — used as the default for trim
   * fabrics (mainTrimFabric + mainTrimFabricInner) when the user
   * switches into a trim layout. Mirrors shade-designer's
   * setWhiteFabric() logic: 8oz canopies use 57003-0000, 9oz canopies
   * use R-099. Each weight is fetched once and reused for the lifetime
   * of the component instance.
   */
  protected whiteFabricByWeight: Record<string, FabricSwatch> = {};
  protected whiteFabricPromiseByWeight: Record<
    string,
    Promise<FabricSwatch>
  > = {};
  protected NoteFields = NoteFields;
  protected getFinishImage = getFinishImage;
  protected ProductLineName = ProductLineName;
  protected selected: UmbrellaModel | null = null;
  protected index: null | number = 0;
  protected ProductType = ProductType;
  protected displayName = "";
  protected model = "";
  protected option = option;
  protected swatch: FabricSwatch | null = null;
  protected ribAttachment = ribAttachment;
  protected hasFinial = hasFinial;
  protected hasBottomPole = hasBottomPole;
  protected productService = new ProductService();
  protected itemPrice = 0;
  protected FabricComponent = FabricComponent;
  protected component: FabricComponent | null = null;
  protected fabricSelectorVisible = false;
  protected ventTopFabricManuallySet = false;
  private syncingVentFabric = false;
  // Mirrors the top-vent sync pattern for the alternating-panel arrays
  // (double-vent middle and valance): mainFabric → arr stays in sync until
  // the user picks a fabric for one of those slots that diverges from the
  // corresponding mainFabric panel. Once flagged manual, the sync stops.
  protected ventMiddleFabricManuallySet = false;
  private syncingVentMiddleFabric = false;
  protected valanceFabricManuallySet = false;
  private syncingValanceFabric = false;
  private ribAutoSwitchedToGrommets = false;
  private ribBeforeAutoSwitch: option.Rib | null = null;
  private suppressRibWatch = false;
  private lastMainFabricCodes: string[] = [];
  // Previous panel-array lengths, captured so the 2→3 mirror watchers can
  // distinguish growth (auto-mirror to 4) from shrinkage (leave at 3 and
  // let the UI show the missing-fabric warning).
  private lastMainFabricLength = 0;
  private lastVentMiddleFabricLength = 0;
  private lastValanceFabricLength = 0;
  protected loader: any = null;
  protected finishDisplayName = FinishDisplayName;
  protected showSpecsModal = false;
  /**
   * Vent selection (Single Vent / Double Vent). After the trim decoupling
   * (Phase 5), `layoutName` is **vent-only** — it no longer holds
   * D1/D2/D3 values. Trim is tracked separately in `selectedTrimOption`.
   */
  protected layoutName:
    | option.StandardLayoutNames
    | option.PresetDesignerNames = option.StandardLayoutNames.Single;
  /**
   * Trim selection — independent of vent. Mirrors shade-designer's
   * `selectedTrimOption`. Possible values:
   *   - "none"   → No Trim (preset = S1 or S1DV depending on vent)
   *   - "single" → Single Trim (preset = D1)
   *   - "double" → Double Trim (preset = D2)
   *   - "triple" → Triple Trim (preset = D3)
   * Trim takes precedence: when trim is active, preset is locked to D1/D2/D3
   * regardless of vent choice; vent only drives the preset when trim is none.
   */
  protected selectedTrimOption: "none" | "single" | "double" | "triple" =
    "none";
  protected designerLayoutName: option.PresetDesignerNames =
    option.PresetDesignerNames.None;
  protected sku = "";
  protected item_details: CustomUmbrellaOrder = {
    canopy: {
      mainCanopy: option.Panel.Solid,
      ventMiddle: null,
      mainFabric: [],
      mainTrimFabric: null,
      mainTrimFabricInner: null,
      ventTopFabric: [],
      ventMiddleFabric: [],
      ventTrimFabric: null,
      valance: option.Valance.Canopy,
      valanceFabric: [],
      fringe: option.Fringe.None,
      fringeFabric: [],
      bindingFabric: null,
      rib: null,
      ribFabric: null,
      undersideFabric: null
    },
    frame: {
      finish: null!,
      finial: null!,
      finialFinish: null,
      bottomPole: option.BottomPole.Standard,
      spigot: null
    },
    layout: {
      productline: {
        handle: this.handle
      },
      preset: option.Preset.S1
    },
    notes: []
  };
  protected noteObj = {
    model: "",
    canopy: "",
    frame: "",
    valance: "",
    fringe: "",
    bottomPole: "",
    finial: "",
    rib: "",
    spigot: ""
  };
  protected showNoteModal = {
    model: false,
    canopy: false,
    frame: false,
    valance: false,
    fringe: false,
    bottomPole: false,
    finial: false,
    rib: false,
    spigot: false
  };
  protected formatTitle = formatTitle;

  /** ALl custom validations should evaluate to true to submit form. Invalid = false */
  @Validations()
  validations() {
    return {
      model: { required },
      item_details: {
        canopy: {
          mainFabric: {
            required,
            minLength: minLength(1),
            maxLength: maxLength(this.maxFabricsAllowed),
            arrayLenEven
          },
          mainTrimFabric: {
            required: requiredIf(
              () => this.selectedTrimOption !== "none"
            ),
            minLength: minLength(1)
          },
          mainTrimFabricInner: {
            required: requiredIf(
              () =>
                this.selectedTrimOption === "double" ||
                this.selectedTrimOption === "triple"
            ),
            minLength: minLength(1)
          },
          ventTopFabric: {
            required: requiredIf(() => this.selected?.attributes.vent),
            minLength: minLength(1),
            maxLength: maxLength(this.maxFabricsAllowed),
            arrayLenEven
          },
          ventMiddleFabric: {
            required: requiredIf(
              () => this.layoutName === option.StandardLayoutNames.Double
            ),
            minLength: minLength(1),
            maxLength: maxLength(this.maxFabricsAllowed),
            arrayLenEven
          },
          valance: {
            required: requiredIf(() => this.selected?.attributes.valance)
          },
          valanceFabric: {
            required: requiredIf(
              () => this.item_details?.canopy.valance !== option.Valance.Canopy
            ),
            minLength: minLength(1),
            maxLength: maxLength(this.maxFabricsAllowed),
            arrayLenEven
          },
          fringe: {},
          fringeFabric: {
            required: requiredIf(
              () =>
                this.fringeFabricsReady &&
                this.item_details?.canopy.fringe !== option.Fringe.None
            ),
            minLength: minLength(1),
            maxLength: maxLength(3)
          },
          // ribFabric: {
          //   required: requiredIf(
          //     () => this.item_details.canopy.rib === option.Rib.Pockets
          //   ),
          //   minLength: minLength(1),
          // },
          rib: {
            required: requiredIf(
              () =>
                this.isGrommetOnlyModel ||
                ribAttachment.grommets.includes(this.handle) ||
                ribAttachment.pockets.includes(this.handle)
            )
          }
        },
        frame: {
          finish: { required },
          finial: {
            required: requiredIf(() => this.hasFinial.includes(this.handle))
          }
        }
      }
    };
  }

  @Watch("model")
  private async onModelChange(): Promise<void> {
    await this.updatePriceAndSKU();
  }

  @Watch("layoutName")
  private async onLayoutNameChange(
    val: option.PresetDesignerNames | option.StandardLayoutNames,
    oldVal: option.PresetDesignerNames | option.StandardLayoutNames
  ): Promise<void> {
    // After the Phase 5 trim decoupling, layoutName is vent-only.
    // Trim is handled independently in `onTrimOptionChange`. This
    // watcher therefore only manages vent state and the preset's
    // vent component (S1 ↔ S1DV when trim is none).
    switch (val) {
      case option.StandardLayoutNames.Single:
        this.item_details.layout.preset = this.computePreset();
        // Reset Double Vent properties when switching to Single Vent.
        this.item_details.canopy.ventMiddle = null;
        this.item_details.canopy.ventMiddleFabric = [];
        await this.updatePriceAndSKU();
        break;

      case option.StandardLayoutNames.Double:
        this.item_details.layout.preset = this.computePreset();
        // Underside and double vent are mutually exclusive; clear
        // underside when enabling double vent.
        this.item_details.canopy.undersideFabric = null;
        // Seed the double-vent fabric array from the current main canopy
        // panels and start in sync mode. The user can later pick a fabric
        // for any double-vent slot — that flips ventMiddleFabricManuallySet
        // and the array stops mirroring main canopy changes.
        this.ventMiddleFabricManuallySet = false;
        if (this.item_details.canopy.mainFabric.length > 0) {
          this.syncingVentMiddleFabric = true;
          (this.item_details.canopy.ventMiddleFabric as FabricSwatch[]) = [
            ...(this.item_details.canopy.mainFabric as FabricSwatch[])
          ];
          this.$nextTick(() => {
            this.syncingVentMiddleFabric = false;
          });
        }
        await this.updatePriceAndSKU();
        break;

      default:
        // Stale designer-preset value slipping through after the trim
        // decoupling — coerce back to a safe vent value. This branch
        // should be unreachable in normal flow.
        this.layoutName =
          oldVal === option.StandardLayoutNames.Single ||
          oldVal === option.StandardLayoutNames.Double
            ? oldVal
            : option.StandardLayoutNames.Single;
        break;
    }
  }

  /**
   * Compute the canopy preset from the current vent + trim selections.
   * Trim takes precedence (D1/D2/D3 are locked by trim regardless of
   * vent state); when trim is "none", the preset is driven by vent
   * (Single → S1, Double → S1DV). Mirrors shade-designer's
   * `trimOptionToPreset` logic.
   */
  protected computePreset(): option.Preset {
    switch (this.selectedTrimOption) {
      case "single":
        return option.Preset.D1;
      case "double":
        return option.Preset.D2;
      case "triple":
        return option.Preset.D3;
      default:
        return this.layoutName === option.StandardLayoutNames.Double
          ? option.Preset.S1DV
          : option.Preset.S1;
    }
  }

  /**
   * Initialize `selectedTrimOption` from a stored canopy preset (used
   * on edit-mode hydration). S1/S1DV → none; D1 → single; D2 → double;
   * D3 → triple; anything else (D4/D5) → none.
   */
  protected presetToTrimOption(
    preset: option.Preset
  ): "none" | "single" | "double" | "triple" {
    switch (preset) {
      case option.Preset.D1:
        return "single";
      case option.Preset.D2:
        return "double";
      case option.Preset.D3:
        return "triple";
      default:
        return "none";
    }
  }

  /**
   * Trim selection watcher — independent of vent. When the user picks
   * a trim option, this seeds (or clears) the trim fabric slots and
   * recomputes the canopy preset. Vent state is left untouched.
   */
  @Watch("selectedTrimOption")
  private async onTrimOptionChange(
    val: "none" | "single" | "double" | "triple"
  ): Promise<void> {
    switch (val) {
      case "single": {
        // Single Trim seeds the outer trim with the canopy-weight white
        // default; inner trim is cleared (only outer applies to D1).
        this.item_details.canopy.mainTrimFabricInner = null;
        if (!this.item_details.canopy.mainTrimFabric) {
          const white = await this.getWhiteTrimFabric(this.canopyWeight);
          if (white) this.item_details.canopy.mainTrimFabric = white;
        }
        break;
      }
      case "double":
      case "triple": {
        // Double / Triple Trim: seed both outer and inner trim with the
        // weight-appropriate white default when either slot is empty.
        const white = await this.getWhiteTrimFabric(this.canopyWeight);
        if (white) {
          if (!this.item_details.canopy.mainTrimFabric) {
            this.item_details.canopy.mainTrimFabric = white;
          }
          if (!this.item_details.canopy.mainTrimFabricInner) {
            this.item_details.canopy.mainTrimFabricInner = white;
          }
        }
        break;
      }
      case "none":
      default: {
        // No Trim — clear both trim fabric slots.
        this.item_details.canopy.mainTrimFabric = null;
        this.item_details.canopy.mainTrimFabricInner = null;
        break;
      }
    }
    this.item_details.layout.preset = this.computePreset();
    await this.updatePriceAndSKU();
  }

  @Watch("item_details.canopy.mainFabric")
  private async mainFabricChange(): Promise<void> {
    // 2→3 panel transition (growth only): auto-mirror the 2nd fabric into
    // the 4th slot so the alternating pattern is ABAB. Shrinking from 4→3
    // leaves the array at 3 so the UI can prompt the user to fill the
    // missing panel rather than silently re-filling it.
    const mainFabricArr = this.item_details.canopy.mainFabric as FabricSwatch[];
    const grewToThree =
      mainFabricArr.length === 3 && this.lastMainFabricLength === 2;
    this.lastMainFabricLength = mainFabricArr.length;
    if (grewToThree) {
      (this.item_details.canopy
        .mainFabric as FabricSwatch[]) = this.mirrorAlternatingPattern(
        mainFabricArr
      );
      return;
    }
    const mainFabric = this.item_details.canopy.mainFabric[0];
    const ventTopFabric = this.item_details.canopy.ventTopFabric[0];
    const ventMiddleFabric = this.item_details.canopy.ventMiddleFabric[0];
    const valanceFabric = this.item_details.canopy.valanceFabric[0];

    // Check if mainFabric actually changed (not just a reference change from canopy object replacement)
    const currentCodes = (this.item_details.canopy
      .mainFabric as FabricSwatch[]).map(f => f.mfr_code);
    const mainFabricActuallyChanged =
      currentCodes.length !== this.lastMainFabricCodes.length ||
      currentCodes.some(
        (code: string, i: number) => code !== this.lastMainFabricCodes[i]
      );
    this.lastMainFabricCodes = currentCodes;

    if (!mainFabricActuallyChanged) {
      return;
    }

    if (mainFabric) {
      if (
        !this.ventTopFabricManuallySet ||
        (ventTopFabric &&
          ventTopFabric.weight !== mainFabric.weight)
      ) {
        this.syncingVentFabric = true;
        (this.item_details.canopy.ventTopFabric as FabricSwatch[]) = [
          mainFabric
        ];
        this.$nextTick(() => { this.syncingVentFabric = false; });
      }
      // Double-vent middle: mirror the entire mainFabric array as long
      // as the user hasn't manually customized any double-vent slot.
      // Weight-mismatch is a hard correctness rule and forces re-sync
      // even after manual changes, matching the previous behavior.
      if (this.item_details.canopy.ventMiddleFabric.length > 0) {
        const weightMismatch =
          ventMiddleFabric && ventMiddleFabric.weight !== mainFabric.weight;
        if (!this.ventMiddleFabricManuallySet || weightMismatch) {
          this.syncingVentMiddleFabric = true;
          (this.item_details.canopy.ventMiddleFabric as FabricSwatch[]) = [
            ...(this.item_details.canopy.mainFabric as FabricSwatch[])
          ];
          if (weightMismatch) this.ventMiddleFabricManuallySet = false;
          this.$nextTick(() => {
            this.syncingVentMiddleFabric = false;
          });
        }
      }
      // Valance: same sync pattern as double-vent middle.
      if (this.item_details.canopy.valanceFabric.length > 0) {
        const weightMismatch =
          valanceFabric && valanceFabric.weight !== mainFabric.weight;
        if (!this.valanceFabricManuallySet || weightMismatch) {
          this.syncingValanceFabric = true;
          (this.item_details.canopy.valanceFabric as FabricSwatch[]) = [
            ...(this.item_details.canopy.mainFabric as FabricSwatch[])
          ];
          if (weightMismatch) this.valanceFabricManuallySet = false;
          this.$nextTick(() => {
            this.syncingValanceFabric = false;
          });
        }
      }
    }
    await this.updatePriceAndSKU();
  }

  @Watch("item_details.canopy.ventMiddleFabric")
  private onVentMiddleFabricChange(): void {
    const arr = this.item_details.canopy.ventMiddleFabric as FabricSwatch[];
    const grewToThree =
      arr.length === 3 && this.lastVentMiddleFabricLength === 2;
    this.lastVentMiddleFabricLength = arr.length;
    if (grewToThree) {
      (this.item_details.canopy
        .ventMiddleFabric as FabricSwatch[]) = this.mirrorAlternatingPattern(
        arr
      );
      return;
    }
    // Detect manual customization: if any slot in ventMiddleFabric
    // diverges from the corresponding mainFabric slot, flag it manual
    // so future mainFabric changes stop overwriting these selections.
    if (this.syncingVentMiddleFabric || this.isStockOnly) return;
    if (this.divergesFromMain(arr)) {
      this.ventMiddleFabricManuallySet = true;
    }
  }

  @Watch("item_details.canopy.valanceFabric")
  private onValanceFabricChange(): void {
    const arr = this.item_details.canopy.valanceFabric as FabricSwatch[];
    const grewToThree =
      arr.length === 3 && this.lastValanceFabricLength === 2;
    this.lastValanceFabricLength = arr.length;
    if (grewToThree) {
      (this.item_details.canopy
        .valanceFabric as FabricSwatch[]) = this.mirrorAlternatingPattern(arr);
      return;
    }
    if (this.syncingValanceFabric || this.isStockOnly) return;
    if (this.divergesFromMain(arr)) {
      this.valanceFabricManuallySet = true;
    }
  }

  /**
   * Per-slot divergence check against the main canopy panels — true if
   * any slot in `arr` has a different fabric mfr_code from the same
   * slot in mainFabric (or if a slot exists in `arr` past the end of
   * mainFabric). Used to flip the manuallySet flags for double-vent
   * middle and valance arrays.
   */
  protected divergesFromMain(arr: readonly FabricSwatch[]): boolean {
    const main = this.item_details.canopy.mainFabric as FabricSwatch[];
    if (arr.length === 0) return false;
    return arr.some((f, i) => {
      const correspondingMain = main[i];
      return !correspondingMain || f.mfr_code !== correspondingMain.mfr_code;
    });
  }

  @Watch("item_details.canopy.ventTopFabric")
  private async onVentTopFabricChange(): Promise<void> {
    if (this.syncingVentFabric || this.isStockOnly) return;
    const mainFabric = this.item_details.canopy.mainFabric[0];
    const ventTopFabric = this.item_details.canopy.ventTopFabric[0];
    if (mainFabric && ventTopFabric) {
      this.ventTopFabricManuallySet =
        ventTopFabric.mfr_code !== mainFabric.mfr_code;
    }
    await this.updatePriceAndSKU();
  }

  @Watch("item_details.canopy.mainTrimFabric")
  private async handleSingleTrimFabricSelection(): Promise<void> {
    if (
      this.item_details.canopy.mainTrimFabric !== null &&
      this.item_details.canopy.mainTrimFabricInner === null &&
      this.item_details.layout.preset === option.Preset.D1
    ) {
      await this.updatePriceAndSKU();
    }
  }

  @Watch("item_details.canopy.mainTrimFabricInner")
  private async handleDoubleOrTripleTrimFabricSelection(): Promise<void> {
    if (
      this.item_details.canopy.mainTrimFabricInner !== null &&
      this.item_details.canopy.mainTrimFabric !== null &&
      (this.item_details.layout.preset === option.Preset.D2 ||
        this.item_details.layout.preset === option.Preset.D3)
    ) {
      await this.updatePriceAndSKU();
    }
  }

  @Watch("item_details.canopy.valance")
  private async setBindingFabric(): Promise<void> {
    if (this.item_details.canopy.valance !== option.Valance.Canopy) {
      // Seed from main canopy fabrics and start in sync mode. The user
      // can later pick a fabric for any valance slot — that flips
      // valanceFabricManuallySet and the array stops mirroring main.
      this.valanceFabricManuallySet = false;
      if (this.item_details.canopy.mainFabric.length > 0) {
        this.syncingValanceFabric = true;
        this.item_details.canopy.valanceFabric = (this.item_details.canopy.mainFabric.filter(
          (f): f is FabricSwatch => !!f
        ) as unknown) as FixedFabricArray;
        this.$nextTick(() => {
          this.syncingValanceFabric = false;
        });
      }

      this.item_details.canopy.bindingFabric = this.item_details.canopy
        .bindingFabric
        ? this.item_details.canopy.bindingFabric
        : await this.getWhp();
    } else {
      this.item_details.canopy.bindingFabric = null;
      this.item_details.canopy.valanceFabric = [];
    }
    await this.updatePriceAndSKU();
  }

  @Watch("item_details.canopy.fringe")
  private async onFringeChange(): Promise<void> {
    if (this.item_details.canopy.fringe === option.Fringe.None) {
      this.item_details.canopy.fringeFabric = [];
    } else {
      // Default the first fringe fabric to WHP when none is set yet,
      // mirroring the valance-binding default behavior.
      if (this.item_details.canopy.fringeFabric.length === 0) {
        const defaultFringe = await this.getWhp();
        if (defaultFringe) {
          this.item_details.canopy.fringeFabric = ([
            defaultFringe
          ] as unknown) as FixedFabricArray;
        }
      } else if (
        this.item_details.canopy.fringeFabric.length > this.maxFringeFabrics
      ) {
        this.item_details.canopy.fringeFabric.splice(this.maxFringeFabrics);
      }
    }
    await this.updatePriceAndSKU();
  }

  @Watch("item_details.canopy.rib")
  private async onRibChange(): Promise<void> {
    if (this.item_details.canopy.rib === option.Rib.Grommets) {
      this.item_details.canopy.ribFabric = null;
    }
    // If this change was from the user (not programmatic), clear auto-switch tracking
    if (!this.suppressRibWatch && this.ribAutoSwitchedToGrommets) {
      this.ribAutoSwitchedToGrommets = false;
      this.ribBeforeAutoSwitch = null;
    }
    await this.updatePriceAndSKU();
  }

  @Watch("item_details.frame.finish")
  private async onFinishChange(): Promise<void> {
    await this.updatePriceAndSKU();
  }

  @Watch("item_details.frame.finialFinish")
  private async onFinialFinishChange(): Promise<void> {
    await this.updatePriceAndSKU();
  }

  @Watch("item_details.frame.bottomPole")
  private async onBottomPoleChange(): Promise<void> {
    await this.updatePriceAndSKU();
  }

  @Watch("item_details.frame.spigot")
  private async onSpigotChange(): Promise<void> {
    if (this.item_details.frame.spigot != null) {
      this.item_details.frame.bottomPole = null;
    }
    await this.updatePriceAndSKU();
  }

  protected readonly maxFabricsAllowed = 4;

  get availableValanceOptions(): option.Valance[] {
    // Filter out VintageScallop until SVG is available
    return Object.values(option.Valance).filter(
      v => v !== option.Valance.VintageScallop
    );
  }

  get isGrommetOnlyModel(): boolean {
    return !!this.selected && grommetOnlyModels.includes(this.selected.model);
  }

  get grommetText(): string {
    if (
      this.isGrommetOnlyModel ||
      this.handle === ProductLineName.Greenwich ||
      this.handle === ProductLineName.GreenwichGSeries ||
      this.handle === ProductLineName.MontereyGSeries ||
      this.handle === ProductLineName.Eclipse ||
      this.handle === ProductLineName.Aurora
    ) {
      return "STANDARD";
    } else {
      return "OPTION";
    }
  }

  get pocketText(): string {
    if (this.isGrommetOnlyModel) {
      return "OPTION";
    }
    if (
      this.handle !== ProductLineName.Greenwich &&
      this.handle !== ProductLineName.GreenwichGSeries &&
      this.handle !== ProductLineName.MontereyGSeries &&
      this.handle !== ProductLineName.Eclipse &&
      this.handle !== ProductLineName.Aurora
    ) {
      return "STANDARD";
    } else {
      return "OPTION";
    }
  }

  get presetDesignerNames(): string[] {
    return Object.values(option.PresetDesignerNames).filter(
      value => value !== option.PresetDesignerNames.None
    );
  }

  /** Trim options shown after the "No Trim" button in the new
   *  Phase 5 trim radio row. The "none" value is rendered separately. */
  get trimOptions(): { value: "single" | "double" | "triple"; label: string }[] {
    return [
      { value: "single", label: "Single Trim" },
      { value: "double", label: "Double Trim" },
      { value: "triple", label: "Triple Trim" }
    ];
  }

  /** True for market-type umbrellas (excluding 882FMC-R, which behaves
   *  like a cantilever for trim sizing). Mirrors shade-designer. */
  get isMarketTrimSizing(): boolean {
    return (
      this.umbrellaType === UmbrellaType.Market &&
      this.selected?.model !== "882FMC-R"
    );
  }

  /**
   * Trim dimension labels shown beneath each trim swatch. Sizes differ
   * between market and non-market umbrellas. Mirrors shade-designer's
   * outerTrimDimension / canopyTrimDimension / innerTrimDimension.
   */
  get outerTrimDimension(): string {
    if (this.selectedTrimOption === "none") return "";
    return '4"';
  }

  get canopyTrimDimension(): string {
    if (this.selectedTrimOption === "double") {
      return '2"';
    }
    if (this.selectedTrimOption === "triple") {
      return '4"';
    }
    return "";
  }

  get innerTrimDimension(): string {
    if (this.selectedTrimOption === "double") {
      return '2"';
    }
    if (this.selectedTrimOption === "triple") {
      return '4"';
    }
    return "";
  }

  get hasCanopyFabricOptions(): boolean {
    if (
      this.handle === ProductLineName.Eclipse ||
      this.handle === ProductLineName.Aurora ||
      this.handle === ProductLineName.Nova ||
      this.handle === ProductLineName.GreenwichGSeries ||
      this.handle === ProductLineName.MontereyGSeries ||
      this.handle === ProductLineName.Greenwich ||
      this.handle === ProductLineName.MontereyPulleyLift ||
      this.handle === ProductLineName.MontereyCrank ||
      this.handle === ProductLineName.MontereyAutoTilt
    ) {
      return true;
    }
    return false;
  }

  /**
   * Show the Canopy "Vent" row only when there is something to render:
   * the product line offers canopy fabric choices, the line has a vent
   * option, or a double-vent layout is active. Prevents an empty label
   * shell on lines with no vent (e.g. Avalon).
   */
  get showVentRow(): boolean {
    return (
      this.hasCanopyFabricOptions ||
      !!this.selected?.attributes.vent ||
      this.layoutName === option.StandardLayoutNames.Double
    );
  }

  /**
   * Show the Canopy "Trim" row only when the product line offers canopy
   * fabric choices or a trim option is currently selected.
   */
  get showTrimRow(): boolean {
    return this.hasCanopyFabricOptions || this.selectedTrimOption !== "none";
  }

  // Finial logic computed properties
  get isGreenwichCollection(): boolean {
    return (
      this.handle === ProductLineName.Greenwich ||
      this.handle === ProductLineName.GreenwichGSeries
    );
  }

  get isMontereyCollection(): boolean {
    return (
      this.handle === ProductLineName.MontereyPulleyLift ||
      this.handle === ProductLineName.MontereyAutoTilt ||
      this.handle === ProductLineName.MontereyCrank ||
      this.handle === ProductLineName.MontereyGSeries
    );
  }

  get finialDefaultType(): string {
    // Greenwich defaults to Vertex, Monterey defaults to Ball
    return this.isGreenwichCollection
      ? option.Finial.Vertex
      : option.Finial.Ball;
  }

  get finialOptionType(): string {
    // Greenwich has Ball as option, Monterey has Vertex as option
    return this.isGreenwichCollection
      ? option.Finial.Ball
      : option.Finial.Vertex;
  }

  get finialDefaultLabel(): string {
    return this.isGreenwichCollection ? "Vertex" : "Classic Ball";
  }

  get finialOptionLabel(): string {
    return this.isGreenwichCollection ? "Classic Ball" : "Vertex";
  }

  get hasFinialFinishNote(): boolean {
    if (this.handle === ProductLineName.Eclipse) return false;
    const finish = this.item_details.frame.finialFinish;
    if (finish === option.FinialFinishType.SS) return true;
    const montereyMarket: ProductLineName[] = [
      ProductLineName.MontereyPulleyLift,
      ProductLineName.MontereyAutoTilt,
      ProductLineName.MontereyCrank
    ];
    if (montereyMarket.includes(this.handle)) {
      return finish === option.FinialFinishType.CH;
    }
    return false;
  }

  get finialFinishNote(): string {
    if (!this.hasFinialFinishNote) return "";
    if (this.item_details.frame.finialFinish === option.FinialFinishType.CH) {
      return "Chrome";
    }
    return "Stainless Steel Upgrade";
  }

  get isNonStandardRib(): boolean {
    if (!this.defaultConfigFile?.canopy?.rib) return false;
    return this.item_details.canopy.rib !== this.defaultConfigFile.canopy.rib;
  }

  get nonStandardRibNote(): string {
    if (!this.isNonStandardRib) return "";
    return this.item_details.canopy.rib === option.Rib.Grommets
      ? "Grommets"
      : "Pockets";
  }

  get isNonStandardBottomPole(): boolean {
    return this.item_details.frame.bottomPole === option.BottomPole.Bar;
  }

  get nonStandardBottomPoleNote(): string {
    if (!this.isNonStandardBottomPole) return "";
    return "Bar Height Bottom Pole upgrade.";
  }

  get isNonStandardFinial(): boolean {
    if (!this.hasFinial.includes(this.handle)) return false;
    return this.item_details.frame.finial !== this.finialDefaultType;
  }

  get nonStandardFinialNote(): string {
    if (!this.isNonStandardFinial) return "";
    return this.finialOptionLabel;
  }

  get hasTPUMatchFinish(): boolean {
    // TPU Match is available for Monterey (Pulley Lift, Crank, Auto Tilt) but NOT G-Series
    return (
      this.handle === ProductLineName.MontereyPulleyLift ||
      this.handle === ProductLineName.MontereyCrank ||
      this.handle === ProductLineName.MontereyAutoTilt
    );
  }

  /**
   * Returns the cached WHP swatch, fetching it once if not already
   * loaded. Concurrent callers share the same in-flight promise so we
   * never fire more than one network request for this default fabric.
   */
  protected async getWhp(): Promise<FabricSwatch> {
    if (this.whpFabric) return this.whpFabric;
    if (!this.whpPromise) {
      this.whpPromise = this.getFabricObject("WHP");
    }
    this.whpFabric = await this.whpPromise;
    return this.whpFabric;
  }

  /**
   * Returns the canopy-weight-appropriate white trim fabric, fetching
   * and caching it on first request. Mirrors shade-designer's
   * setWhiteFabric(): 8oz → 57003-0000, 9oz → R-099. Returns null for
   * any other weight (callers should skip seeding in that case).
   */
  protected async getWhiteTrimFabric(
    weight: string
  ): Promise<FabricSwatch | null> {
    const mfrCodeByWeight: Record<string, string> = {
      "8": "57003-0000",
      "9": "R-099"
    };
    const mfrCode = mfrCodeByWeight[weight];
    if (!mfrCode) return null;
    if (this.whiteFabricByWeight[weight]) {
      return this.whiteFabricByWeight[weight];
    }
    if (!this.whiteFabricPromiseByWeight[weight]) {
      this.whiteFabricPromiseByWeight[weight] = this.getFabricObject(mfrCode);
    }
    this.whiteFabricByWeight[weight] = await this.whiteFabricPromiseByWeight[
      weight
    ];
    return this.whiteFabricByWeight[weight];
  }

  /** Resolves the current canopy fabric's weight, defaulting to "9" if
   *  none is set yet — matches how filterMainFabricWeight defaults. */
  protected get canopyWeight(): string {
    const w = this.item_details.canopy.mainFabric[0]?.weight;
    return w || "9";
  }

  /**
   * Repeating-pattern panel arrays (main canopy, double vent middle,
   * valance) jump from 3 panels back up to 4 by mirroring the 2nd
   * panel into the 4th slot — i.e. an ABAB alternating pattern.
   * Returns the mirrored array when input length is exactly 3, or the
   * input array unchanged otherwise. Returns a new array reference so
   * Vue reactivity picks up the change.
   */
  protected mirrorAlternatingPattern(
    arr: readonly FabricSwatch[]
  ): FabricSwatch[] {
    if (arr.length !== 3) return arr as FabricSwatch[];
    return [arr[0], arr[1], arr[2], arr[1]];
  }

  async created() {
    this.showLoader();
    // Kick off the WHP fetch + both weight-keyed white trim fetches in
    // parallel with the other init work — these are the default fabrics
    // for valance binding, fringe, and the Single/Double/Triple Trim
    // layouts. Caching them up front means switching trim layouts later
    // doesn't trigger a fresh network round-trip.
    const defaultsKickoff = Promise.all([
      this.getWhp(),
      this.getWhiteTrimFabric("8"),
      this.getWhiteTrimFabric("9")
    ]);
    const defaults = await this.getProductLineInfo();
    this.displayName = defaults.display_name;
    this.defaultConfigFile = defaults.config_file_id! as ConfigFile;
    this.umbrellaType = defaults.umbrella_type ?? null;
    // Ensure the default-fabric cache is primed before any code path that
    // may need it (the await is essentially free once resolved).
    await defaultsKickoff;
    if (!this.$route.params.edit && this.$route.query.cart) {
      // if a user refreshes or back buttons onto this page, redirect to expired notice. because we are using index to update item, the user must navigate directly from the cart, or we can't guarantee the index is correct
      this.$router.replace("/resubmit");
      this.closeLoader();
    } else if (this.$route.params.edit && this.$route.query.cart) {
      await this.getItems(this.product, this.handle);
      this.editMode = true;
      this.isStockOnly = false;
      const index = parseInt(this.$route.query.cart as string, 10);
      await this.prepDataForEdit(index);
    } else {
      await this.getItems(this.product, this.handle);
      await this.setDefaults();
      this.setBindingFabric();
      this.updatePriceAndSKU();
    }
    this.closeLoader();
  }

  protected async toggleStock(): Promise<void> {
    this.isStockOnly = !this.isStockOnly;
    if (this.isStockOnly) {
      this.item_details.canopy.ventMiddle = null;
      this.item_details.canopy.ventMiddleFabric = [];
      this.item_details.canopy.mainTrimFabric = null;
      this.item_details.canopy.mainTrimFabricInner = null;
      this.layoutName = option.StandardLayoutNames.Single;
      this.selectedTrimOption = "none";

      this.ribAutoSwitchedToGrommets = false;
      this.ribBeforeAutoSwitch = null;
      if (this.isGrommetOnlyModel) {
        this.item_details.canopy.rib = option.Rib.Grommets;
        this.item_details.canopy.ribFabric = null;
      } else {
        this.item_details.canopy.rib = this.defaultConfigFile!.canopy!.rib;
      }
      if (
        this.handle === ProductLineName.Eclipse ||
        this.handle === ProductLineName.Greenwich ||
        this.handle === ProductLineName.GreenwichGSeries
      ) {
        this.item_details.frame.finial = option.Finial.Vertex;
      } else if (this.hasFinial.includes(this.handle)) {
        this.item_details.frame.finial = option.Finial.Ball;
      }
      // Reset finial finish to default when toggling to stock
      if (this.handle === ProductLineName.Eclipse) {
        this.item_details.frame.finialFinish = option.FinialFinishType.SS;
      } else if (this.hasTPUMatchFinish) {
        this.item_details.frame.finialFinish = option.FinialFinishType.TPU;
      } else {
        this.item_details.frame.finialFinish = option.FinialFinishType.CH;
      }
      this.item_details.frame.bottomPole = option.BottomPole.Standard;
      (this.item_details.canopy.valance = option.Valance.Canopy),
        (this.item_details.canopy.valanceFabric = []);
      (this.item_details.canopy.fringe = option.Fringe.None),
        (this.item_details.canopy.fringeFabric = []);
      this.item_details.canopy.mainFabric.splice(1);
      this.ventTopFabricManuallySet = false;
      this.syncingVentFabric = true;
      (this.item_details.canopy.ventTopFabric as FabricSwatch[]) = [
        ...this.item_details.canopy.mainFabric
      ];
      this.$nextTick(() => { this.syncingVentFabric = false; });
    }
  }

  get toggleImg(): string {
    if (!this.isStockOnly) {
      return require("../../assets/images/toggle-true.png");
    } else {
      return require("../../assets/images/toggle-false.png");
    }
  }

  protected closeSpecsModal(): void {
    this.showSpecsModal = false;
  }

  protected toggleSpecsModal(): void {
    this.showSpecsModal = true;
  }

  protected mobileSetFinish(handle: FinishHandle): void {
    this.item_details.frame.finish = handle;
  }

  protected async prepDataForEdit(index: number): Promise<void> {
    try {
      const storeItemCopy = JSON.parse(
        JSON.stringify(this.storeItems[index])
      ) as LineItem;
      const itemDetails = storeItemCopy.item_details as CustomUmbrellaOrder;

      const mainFabric = [] as FabricSwatch[];
      for (const swatch of itemDetails.canopy.mainFabric) {
        let fabric;
        if (!swatch.mfr_code) {
          fabric = await this.getFabricObject(swatch as any);
        } else {
          fabric = swatch;
        }
        mainFabric.push(fabric);
      }

      let mainTrimFabric: FabricSwatch | null = null;
      if (
        itemDetails.canopy.mainTrimFabric &&
        !itemDetails.canopy.mainTrimFabric.mfr_code
      ) {
        mainTrimFabric = await this.getFabricObject(
          itemDetails.canopy.mainTrimFabric as any
        );
      } else {
        mainTrimFabric = itemDetails.canopy.mainTrimFabric;
      }

      let mainTrimFabricInner: FabricSwatch | null = null;
      if (
        itemDetails.canopy.mainTrimFabricInner &&
        !itemDetails.canopy.mainTrimFabricInner.mfr_code
      ) {
        mainTrimFabricInner = await this.getFabricObject(
          itemDetails.canopy.mainTrimFabricInner as any
        );
      } else {
        mainTrimFabricInner = itemDetails.canopy.mainTrimFabricInner;
      }

      const ventTopFabric = [] as FabricSwatch[];
      for (const swatch of itemDetails.canopy.ventTopFabric) {
        let fabric;
        if (!swatch.mfr_code) {
          fabric = await this.getFabricObject(swatch as any);
        } else {
          fabric = swatch;
        }
        ventTopFabric.push(fabric);
      }

      const ventMiddleFabric = [] as FabricSwatch[];
      for (const swatch of itemDetails.canopy.ventMiddleFabric) {
        let fabric;
        if (!swatch.mfr_code) {
          fabric = await this.getFabricObject(swatch as any);
        } else {
          fabric = swatch;
        }
        ventMiddleFabric.push(fabric);
      }

      const startingLayout = this.defaultConfigFile
        ? this.defaultConfigFile.layout
        : ({} as ConfigFile["layout"]);
      if (startingLayout.collection) {
        delete startingLayout.collection;
      }
      if (!(mainTrimFabric || mainTrimFabricInner)) {
        if (ventTopFabric.length > 0 && ventMiddleFabric.length > 0) {
          startingLayout.preset = option.Preset.S1DV;
        } else if (ventTopFabric.length > 0) {
          startingLayout.preset = option.Preset.S1;
        }
      }

      const valanceFabric = [] as FabricSwatch[];
      if (itemDetails.canopy.valanceFabric.length > 0) {
        for (const swatch of itemDetails.canopy.valanceFabric) {
          let fabric;
          if (!swatch.mfr_code) {
            fabric = await this.getFabricObject(swatch as any);
          } else {
            fabric = swatch;
          }
          valanceFabric.push(fabric);
        }
      }

      const fringeFabric = [] as FabricSwatch[];
      if (
        itemDetails.canopy.fringeFabric &&
        itemDetails.canopy.fringeFabric.length > 0
      ) {
        for (const swatch of itemDetails.canopy.fringeFabric) {
          let fabric;
          if (!swatch.mfr_code) {
            fabric = await this.getFabricObject(swatch as any);
          } else {
            fabric = swatch;
          }
          fringeFabric.push(fabric);
        }
      }

      let ribFabric: FabricSwatch | null = null;
      if (itemDetails.canopy.rib === option.Rib.Pockets) {
        ribFabric = mainFabric[0];
      } else {
        ribFabric = null;
      }

      let bindingFabric: FabricSwatch | null = null;
      if (itemDetails.canopy.bindingFabric) {
        if (!itemDetails.canopy.bindingFabric.mfr_code) {
          bindingFabric = await this.getFabricObject(
            itemDetails.canopy.bindingFabric as any
          );
        }
      }

      const foundItem = this.items.find(item => item.model === storeItemCopy.model);
      this.selected = foundItem ? foundItem : this.items[0];
      this.model = this.selected!.model;
      const canopy = Object.assign(
        {},
        {
          ...itemDetails.canopy
        },
        {
          mainFabric: mainFabric,
          mainTrimFabric: mainTrimFabric,
          mainTrimFabricInner: mainTrimFabricInner,
          ventTopFabric: ventTopFabric,
          ventMiddleFabric: ventMiddleFabric,
          valanceFabric: valanceFabric,
          fringeFabric: fringeFabric,
          bindingFabric: bindingFabric,
          ribFabric: ribFabric
        }
      );

      const layout = itemDetails.layout ? itemDetails.layout : startingLayout;
      const newObj = Object.assign(
        {},
        { ...itemDetails },
        { canopy },
        { layout }
      ) as CustomUmbrellaOrder;
      this.item_details = Object.assign({}, this.item_details, newObj);
      if (this.item_details.notes && this.item_details.notes.length > 0) {
        this.setNotes();
      } else {
        this.item_details.notes = [];
      }
    } catch (error) {
      console.error("error occurred when editing a cart item:", error);
    } finally {
      this.lastMainFabricCodes = (this.item_details.canopy
        .mainFabric as FabricSwatch[]).map(f => f.mfr_code);
      this.checkMainCanopy();
      this.setLayoutName();
      this.checkVentMiddle();
      await this.updateSKU();
    }
  }

  protected setNotes(): void {
    const uf = [
      "model",
      "canopy",
      "frame",
      "valance",
      "fringe",
      "finial",
      "bottomPole",
      "rib",
      "spigot"
    ];
    uf.forEach(field => {
      const obj = this.item_details.notes!.find(e => e.field === field);
      if (obj) {
        let content = obj.content;
        if (field === "spigot") {
          content = content.replace(/^Stainless Steel\.?\s*/i, "").trim();
        }
        if (field === "rib") {
          content = content.replace(/^Grommets\.?\s*/i, "").trim();
          content = content.replace(/^Pockets\.?\s*/i, "").trim();
        }
        if (field === "bottomPole") {
          content = content
            .replace(/^Bar Height Bottom Pole upgrade\.?\s*/i, "")
            .trim();
        }
        if (field === "finial") {
          content = content.replace(/^Stainless Steel Upgrade\.?\s*/i, "").trim();
          content = content.replace(/^Chrome\.?\s*/i, "").trim();
          content = content.replace(/^Vertex\.?\s*/i, "").trim();
          content = content.replace(/^Classic Ball\.?\s*/i, "").trim();
        }
        this.noteObj[field] = content;
      }
    });
  }

  protected addNotesToQuote(): void {
    this.item_details.notes = [];
    for (const [key, value] of Object.entries(this.noteObj)) {
      let content = value;
      if (
        key === "spigot" &&
        this.handle === ProductLineName.Aurora &&
        this.item_details.frame.spigot === option.Spigot.StainlessSteel
      ) {
        const spigotLabel = "Stainless Steel";
        content = content ? `${spigotLabel}. ${content}` : spigotLabel;
      }
      if (key === "rib" && this.isNonStandardRib) {
        const ribLabel = this.nonStandardRibNote;
        content = content ? `${ribLabel}. ${content}` : ribLabel;
      }
      if (key === "bottomPole" && this.isNonStandardBottomPole) {
        const bpLabel = this.nonStandardBottomPoleNote;
        content = content ? `${bpLabel} ${content}` : bpLabel;
      }
      if (key === "finial" && this.isNonStandardFinial) {
        const finialLabel = this.nonStandardFinialNote;
        content = content ? `${finialLabel}. ${content}` : finialLabel;
      }
      if (key === "finial" && this.hasFinialFinishNote) {
        const finishLabel = this.finialFinishNote;
        content = content ? `${finishLabel}. ${content}` : finishLabel;
      }
      this.item_details.notes.push({
        field: key as NoteFields,
        content
      });
    }
  }

  protected showLoader(): void {
    this.loader = this.$loading.show({
      opacity: 1
    });
  }

  protected closeLoader(): void {
    setTimeout(() => {
      this.loader.hide();
    }, 300);
    this.$emit("ready");
  }

  get showBottomPole(): boolean {
    let show = false;
    if (this.hasBottomPole.includes(this.handle)) {
      show = true;
    }
    return show;
  }

  get vCanopyObj() {
    return this.$v.item_details.canopy;
  }

  get canopyEvenErrors(): string[] {
    const errors: string[] = [];
    const fields = [
      { label: "Main fabric", arr: this.item_details.canopy.mainFabric },
      { label: "Top vent fabric", arr: this.item_details.canopy.ventTopFabric },
      ...(this.layoutName === option.StandardLayoutNames.Double
        ? [{ label: "Double vent fabric", arr: this.item_details.canopy.ventMiddleFabric }]
        : [])
    ];
    for (const f of fields) {
      if (f.arr && f.arr.length > 1 && f.arr.length % 2 !== 0) {
        errors.push(
          `${f.label}: more than one fabric must be selected in groups of two; canopies have an even number of segments. Please add or remove a fabric.`
        );
      }
    }
    return errors;
  }

  get fringeFabricsReady(): boolean {
    return process.env.VUE_APP_FRINGE_FABRICS_READY === "true";
  }

  private hasEvenError(arr: { length: number }): boolean {
    return arr && arr.length > 1 && arr.length % 2 !== 0;
  }

  get hasMainFabricEvenError(): boolean {
    return this.hasEvenError(this.item_details.canopy.mainFabric);
  }

  get hasDoubleVentEvenError(): boolean {
    return this.layoutName === option.StandardLayoutNames.Double &&
      this.hasEvenError(this.item_details.canopy.ventMiddleFabric);
  }

  get hasValanceEvenError(): boolean {
    return this.hasEvenError(this.item_details.canopy.valanceFabric);
  }

  get canopyAlerts(): string[] {
    return this.canopyEvenErrors;
  }

  get vFrameObj() {
    return this.$v.item_details.frame;
  }

  protected async setDefaults(): Promise<void> {
    const defaultConfig = this.defaultConfigFile!;
    const mainFabric = await this.getFabricObject(
      defaultConfig.canopy!.mainFabric[0]
    );
    this.selected = this.items[0];
    this.model = this.selected!.model;
    this.item_details.frame.finish = defaultConfig.frame!.finish;
    this.item_details.canopy.mainFabric = [mainFabric];
    this.lastMainFabricCodes = [mainFabric.mfr_code];
    this.item_details.canopy.ventTopFabric = [mainFabric];
    this.ventTopFabricManuallySet = false;
    this.ribAutoSwitchedToGrommets = false;
    this.ribBeforeAutoSwitch = null;
    if (grommetOnlyModels.includes(this.selected!.model)) {
      this.item_details.canopy.rib = option.Rib.Grommets;
      this.item_details.canopy.ribFabric = null;
    } else {
      this.item_details.canopy.rib = defaultConfig.canopy!.rib;
      if (defaultConfig.canopy!.rib === option.Rib.Pockets) {
        this.item_details.canopy.ribFabric = mainFabric;
      }
    }
    // Set default finial type based on collection
    if (
      this.handle === ProductLineName.Eclipse ||
      this.handle === ProductLineName.Greenwich ||
      this.handle === ProductLineName.GreenwichGSeries
    ) {
      this.item_details.frame.finial = option.Finial.Vertex;
    } else if (this.hasFinial.includes(this.handle)) {
      this.item_details.frame.finial = option.Finial.Ball;
    }
    // Set default spigot based on collection
    if (this.handle === ProductLineName.Aurora) {
      this.item_details.frame.spigot = option.Spigot.Standard;
    } else if (this.handle === ProductLineName.Eclipse) {
      this.item_details.frame.spigot = option.Spigot.StainlessSteel;
    } else {
      this.item_details.frame.spigot = null;
    }
    // Set default finial finish based on collection
    if (this.handle === ProductLineName.Eclipse) {
      this.item_details.frame.finialFinish = option.FinialFinishType.SS;
    } else if (this.hasTPUMatchFinish) {
      // Monterey Pulley Lift, Crank, Auto Tilt default to TPU Match
      this.item_details.frame.finialFinish = option.FinialFinishType.TPU;
    } else {
      // Greenwich and Monterey G-Series default to Chrome
      this.item_details.frame.finialFinish = option.FinialFinishType.CH;
    }
  }

  protected async updatePriceAndSKU(): Promise<void> {
    await this.updatePrice();
    await this.updateSKU();
  }

  protected async updatePrice(): Promise<void> {
    if (
      this.item_details.frame.finish &&
      this.item_details.canopy.mainFabric.length > 0
    ) {
      this.checkVentMiddle();
      this.checkMainCanopy();
      this.checkCanopyLayout();
      try {
        const price = await this.productService.getUmbrellaPrice({
          model: this.model,
          item_details: this.item_details
        });
        console.log(
          "Fringe:",
          this.item_details.canopy.fringe,
          "| Total Price:",
          price.umbrella
        );
        this.itemPrice = price.umbrella!;
      } catch (err) {
        if (err instanceof AuthError) {
          AuthError.logout();
        }
        GenericError.popup((err as any).message);
      }
    } else {
      this.getMSRP();
    }
  }

  protected async updateSKU(): Promise<void> {
    const data = this.transformDataToConfigFile();
    const sku = await this.productService.createFinishedUmbrellaSKU(data);
    this.sku = sku;
  }

  protected transformDataToConfigFile(): ConfigFile {
    /**
     * Encode a fabric reference for the SKU pipeline / saved configs.
     * Returns "<mfr_code>::<group>" when the fabric carries a name.group
     * (used by the API to disambiguate duplicate mfr_codes — e.g. SENS D-020
     * across Coquette / Finesse / Enea — and harmless when emitted on a
     * non-duplicate fabric since the API only consults the suffix when the
     * bare lookup is ambiguous). Falls back to bare "<mfr_code>" otherwise.
     */
    const encodeFabric = (f: FabricSwatch): string => {
      const group = f.name && f.name.group;
      return group ? `${f.mfr_code}::${group}` : f.mfr_code;
    };

    const fabricArray = (this.item_details.canopy.mainFabric as Array<
      FabricSwatch
    >).map(encodeFabric);
    const fabricArrayVentTop = this.selected!.attributes.vent
      ? (this.item_details.canopy.ventTopFabric as Array<FabricSwatch>).map(
          encodeFabric
        )
      : [];
    const fabricArrayVentMid = (this.item_details.canopy
      .ventMiddleFabric as Array<FabricSwatch>).map(encodeFabric);
    const fabricArrayValance = (this.item_details.canopy.valanceFabric as Array<
      FabricSwatch
    >).map(encodeFabric);
    const fabricArrayFringe = (this.item_details.canopy.fringeFabric as Array<
      FabricSwatch
    >).map(encodeFabric);
    const data: ConfigFile = {
      layout: this.item_details.layout,
      shape: { model: this.selected?.model || "" },
      base: {
        base: null,
        baseFinish: null,
        baseStem: null
      },
      frame: {
        finish: this.item_details.frame.finish,
        finial: this.item_details.frame.finial,
        finialFinish: this.item_details.frame.finialFinish,
        bottomPole: this.item_details.frame.bottomPole,
        ...(this.handle === ProductLineName.Aurora
          ? { spigot: this.item_details.frame.spigot }
          : {})
      },
      canopy: {
        mainCanopy: this.item_details.canopy.mainCanopy,
        mainTrimFabric: this.item_details.canopy.mainTrimFabric
          ? encodeFabric(this.item_details.canopy.mainTrimFabric)
          : null,
        mainTrimFabricInner: this.item_details.canopy.mainTrimFabricInner
          ? encodeFabric(this.item_details.canopy.mainTrimFabricInner)
          : null,
        mainFabric: fabricArray,
        ventTopFabric: fabricArrayVentTop,
        ventMiddle: this.item_details.canopy.ventMiddle,
        ventMiddleFabric: fabricArrayVentMid,
        valanceFabric: fabricArrayValance,
        fringe: this.item_details.canopy.fringe,
        fringeFabric: fabricArrayFringe,
        ventTrimFabric: this.item_details.canopy.ventTrimFabric
          ? encodeFabric(this.item_details.canopy.ventTrimFabric)
          : null,
        valance: this.item_details.canopy.valance,
        bindingFabric: this.item_details.canopy.bindingFabric
          ? encodeFabric(this.item_details.canopy.bindingFabric)
          : null,
        rib: this.item_details.canopy.rib,
        ribFabric:
          !this.item_details.canopy.rib ||
          this.item_details.canopy.rib === option.Rib.Grommets
            ? null
            : fabricArray[0],
        undersideFabric: this.item_details.canopy.undersideFabric
          ? encodeFabric(this.item_details.canopy.undersideFabric)
          : null
      }
    };
    return data;
  }

  protected async getMSRP(): Promise<void> {
    try {
      const price = await this.productService.getPriceDoc(this.model);
      this.itemPrice = price.a!;
    } catch (err) {
      if (err instanceof AuthError) {
        AuthError.logout();
      }
      GenericError.popup((err as any).message);
    }
  }

  protected checkVentMiddle(): void {
    if (this.layoutName === option.StandardLayoutNames.Double) {
      if (this.item_details.canopy.ventMiddleFabric.length < 2) {
        this.item_details.canopy.ventMiddle = option.Panel.Solid;
      } else {
        this.item_details.canopy.ventMiddle = option.Panel.Alternating;
      }
    } else {
      this.item_details.canopy.ventMiddle = null;
      this.item_details.canopy.ventMiddleFabric = [];
    }
    // After the Phase 5 decoupling, preset is derived from vent + trim
    // together — `computePreset` is the canonical source. Trim takes
    // precedence (D1/D2/D3); vent only drives S1 / S1DV when trim is none.
    this.item_details.layout.preset = this.computePreset();
  }

  protected checkMainCanopy(): void {
    if (this.item_details.canopy.mainFabric.length > 1) {
      this.item_details.canopy.mainCanopy = option.Panel.Alternating;
    } else {
      this.item_details.canopy.mainCanopy = option.Panel.Solid;
    }
  }

  /**
   * Hydrate `layoutName` (vent) and `selectedTrimOption` (trim) from
   * the stored `canopy.layout.preset`. After the Phase 5 decoupling,
   * preset encodes both vent and trim — but layoutName is vent-only,
   * so trim comes from `presetToTrimOption`.
   */
  protected setLayoutName(): void {
    const preset = this.item_details.layout.preset;
    this.layoutName =
      preset === option.Preset.S1DV ||
      preset === option.Preset.D1 ||
      preset === option.Preset.D2 ||
      preset === option.Preset.D3
        ? // Trim presets don't encode vent directly; default to Single Vent
          // for D1/D2/D3 unless explicitly S1DV. (Legacy data may have set
          // a trim preset alongside double-vent before decoupling; the
          // S1DV case is preserved separately.)
          preset === option.Preset.S1DV
          ? option.StandardLayoutNames.Double
          : option.StandardLayoutNames.Single
        : option.StandardLayoutNames.Single;
    this.selectedTrimOption = this.presetToTrimOption(preset);
  }

  protected checkCanopyLayout(): void {
    // After the Phase 5 decoupling, preset is derived from BOTH vent
    // (layoutName) and trim (selectedTrimOption) — `computePreset` is
    // the canonical source.
    this.item_details.layout.preset = this.computePreset();
  }

  protected addToQuote(item: LineItem) {
    this.$v.$touch();
    if (!this.$v.$invalid) {
      this.checkMainCanopy();
      this.checkVentMiddle();
      this.checkCanopyLayout();
      this.addNotesToQuote();
      const orderItem = { ...item, item_details: this.item_details };
      orderItem.sku = this.sku;
      this.addItem(orderItem);
      const numberPrice =
        orderItem.unit_price * orderItem.multiplier * orderItem.qty;
      EventBus.$emit("addToCartModal", {
        qty: orderItem.qty,
        cost: numberPrice,
        model: orderItem.model,
        productline: orderItem.product_line,
        name: orderItem.display_name,
        finish: orderItem.item_details.frame.finish,
        fabric: this.item_details.canopy.mainFabric,
        fringe: this.item_details.canopy.fringe,
        fringeFabric: this.item_details.canopy.fringeFabric,
        sku: orderItem.sku,
        valance: this.item_details.canopy.valance,
        valanceFabric: this.item_details.canopy.valanceFabric,
        bindingFabric: this.item_details.canopy.bindingFabric,
        undersideFabric: this.item_details.canopy.undersideFabric,
        finial: this.item_details.frame.finial,
        finialFinish: this.item_details.frame.finialFinish,
        bottomPole: this.item_details.frame.bottomPole,
        spigot: this.item_details.frame.spigot,
        rib: this.item_details.canopy.rib
      });
      this.editMode = true;
    } else {
      console.error("Error adding item to cart");
    }
  }

  protected editQuote(item: LineItem) {
    const index = parseInt(this.$route.query.cart as string, 10);
    this.$v.$touch();
    if (!this.$v.$invalid) {
      if (this.item_details.canopy.mainFabric.length > 1) {
        this.item_details.canopy.mainCanopy = option.Panel.Alternating;
      } else {
        this.item_details.canopy.mainCanopy = option.Panel.Solid;
      }
      this.addNotesToQuote();
      // The footer's lineItem doesn't carry NetSuite line identity
      // (ns_line_id, ns_locked). Merge the edited fields onto the original
      // stored line so a NetSuite-added/linked line keeps its identity and is
      // still recognized as an update — not a brand-new line — on resubmit.
      const original = this.storeItems[index];
      const orderItem = {
        ...original,
        ...item,
        item_details: this.item_details
      };
      orderItem.sku = this.sku;
      this.editLineItem({ item: orderItem, index: index });
      const numberPrice =
        orderItem.unit_price * orderItem.multiplier * orderItem.qty;
      EventBus.$emit("addToCartModal", {
        qty: orderItem.qty,
        cost: numberPrice,
        model: orderItem.model,
        productline: orderItem.product_line,
        name: orderItem.display_name,
        finish: orderItem.item_details.frame.finish,
        fabric: this.item_details.canopy.mainFabric,
        fringe: this.item_details.canopy.fringe,
        fringeFabric: this.item_details.canopy.fringeFabric,
        sku: orderItem.sku,
        valance: this.item_details.canopy.valance,
        valanceFabric: this.item_details.canopy.valanceFabric,
        bindingFabric: this.item_details.canopy.bindingFabric,
        undersideFabric: this.item_details.canopy.undersideFabric,
        finial: this.item_details.frame.finial,
        finialFinish: this.item_details.frame.finialFinish,
        bottomPole: this.item_details.frame.bottomPole,
        spigot: this.item_details.frame.spigot,
        rib: this.item_details.canopy.rib
      });
    }
  }

  protected toggleModal(field: NoteFields): void {
    this.showNoteModal[field] = true;
  }

  protected closeModal(): void {
    this.showNoteModal = {
      model: false,
      canopy: false,
      frame: false,
      valance: false,
      fringe: false,
      bottomPole: false,
      finial: false,
      rib: false,
      spigot: false
    };
  }

  protected showFabricSelector(
    selection: FabricComponent,
    swatch: FabricSwatch | null,
    index = null
  ): void {
    this.$v.$reset();
    this.swatch = swatch;
    this.index = index;
    // For the main canopy panels, the component name is derived from the
    // slot index rather than the caller-supplied selection: index 0 is the
    // primary Main panel, anything higher is an alternating panel. This
    // keeps the picker's title in sync even when the template fires
    // `MainAlternating` for every multi-panel swatch tile.
    if (
      selection === FabricComponent.Main ||
      selection === FabricComponent.MainAlternating
    ) {
      this.component =
        this.index !== null && this.index > 0
          ? FabricComponent.MainAlternating
          : FabricComponent.Main;
    } else {
      this.component = selection;
    }
    this.fabricSelectorVisible = true;
  }

  protected changeSelectedModel(item: UmbrellaModel): void {
    // Defense for direct invocations (e.g. mobile Dropdown). When the
    // target model is disabled for the current striped-fabric state,
    // revert to whatever was previously selected.
    if (this.isModelDisabledForStripes(item)) {
      if (this.selected) {
        this.model = this.selected.model;
      }
      return;
    }
    const wasGrommetOnly = this.isGrommetOnlyModel;
    this.selected = item;
    this.model = item.model;
    const nowGrommetOnly = grommetOnlyModels.includes(item.model);

    if (nowGrommetOnly && !wasGrommetOnly) {
      // Entering a grommet-only model: save current rib and auto-switch
      this.ribBeforeAutoSwitch = this.item_details.canopy.rib;
      this.ribAutoSwitchedToGrommets = true;
      this.suppressRibWatch = true;
      this.item_details.canopy.rib = option.Rib.Grommets;
      this.item_details.canopy.ribFabric = null;
      this.$nextTick(() => { this.suppressRibWatch = false; });
    } else if (!nowGrommetOnly && wasGrommetOnly && this.ribAutoSwitchedToGrommets) {
      // Leaving a grommet-only model and user never manually chose grommets: restore
      this.suppressRibWatch = true;
      this.item_details.canopy.rib = this.ribBeforeAutoSwitch;
      if (this.item_details.canopy.rib !== option.Rib.Pockets) {
        this.item_details.canopy.ribFabric = null;
      }
      this.ribAutoSwitchedToGrommets = false;
      this.ribBeforeAutoSwitch = null;
      this.$nextTick(() => { this.suppressRibWatch = false; });
    } else if (nowGrommetOnly && wasGrommetOnly) {
      // Switching between grommet-only models: keep forced grommets, preserve saved rib
      this.suppressRibWatch = true;
      this.item_details.canopy.rib = option.Rib.Grommets;
      this.item_details.canopy.ribFabric = null;
      this.$nextTick(() => { this.suppressRibWatch = false; });
    }

    if (this.isUndersideDisabled) {
      this.item_details.canopy.undersideFabric = null;
    }
  }

  get maxFringeFabrics(): number {
    return this.item_details.canopy.fringe === option.Fringe.Brush ? 2 : 3;
  }

  get umbrellas(): UmbrellaModel[] {
    return this.items as UmbrellaModel[];
  }

  get finishes(): UmbrellaModel["finishes"] {
    return this.selected!.finishes.sort((a, b) =>
      a.handle > b.handle ? 1 : -1
    );
  }

  protected deleteMainSwatch(index: number): void {
    this.item_details.canopy.mainFabric.splice(index, 1);
    this.updatePriceAndSKU();
  }

  protected deleteVentSwatch(index: number): void {
    this.item_details.canopy.ventTopFabric.splice(index, 1);
    this.updatePriceAndSKU();
  }

  protected deleteMiddleVentSwatch(index: number): void {
    this.item_details.canopy.ventMiddleFabric.splice(index, 1);
    this.updatePriceAndSKU();
  }

  protected deleteOuterTrimSwatch(): void {
    this.item_details.canopy.mainTrimFabric = null;
    this.updatePriceAndSKU();
  }

  protected deleteInnerTrimSwatch(): void {
    this.item_details.canopy.mainTrimFabricInner = null;
    this.updatePriceAndSKU();
  }

  protected deleteUndersideSwatch(): void {
    this.item_details.canopy.undersideFabric = null;
    this.updatePriceAndSKU();
  }

  get isDoubleVent(): boolean {
    return this.layoutName === option.StandardLayoutNames.Double;
  }

  private readonly noUndersideModels = ["876FMA-R", "882FMC-R"];

  get isUndersideDisabledByModel(): boolean {
    return this.selected?.model != null && this.noUndersideModels.includes(this.selected.model);
  }

  get isUndersideDisabled(): boolean {
    return this.isDoubleVent || this.isUndersideDisabledByModel;
  }

  /**
   * 5" Bullion fringe is incompatible with the French and Roman valance
   * styles (the long bullion strands physically interfere with those
   * scalloped/draped valance shapes). Mirrors shade-designer.
   *
   * Bidirectional disable:
   *   - isBullion5RestrictedByValance: true when the current valance is
   *     French or Roman — used to disable the 5" Bullion fringe option.
   *   - disabledValances: returns the list of valance values to disable
   *     when 5" Bullion is currently selected.
   */
  get isBullion5RestrictedByValance(): boolean {
    return (
      this.item_details.canopy.valance === option.Valance.French ||
      this.item_details.canopy.valance === option.Valance.Roman
    );
  }

  get disabledValances(): option.Valance[] {
    return this.item_details.canopy.fringe === option.Fringe.Bullion5
      ? [option.Valance.French, option.Valance.Roman]
      : [];
  }

  protected isFringeOptionDisabled(fringeOption: option.Fringe): boolean {
    return (
      fringeOption === option.Fringe.Bullion5 &&
      this.isBullion5RestrictedByValance
    );
  }

  protected isValanceOptionDisabled(valance: option.Valance): boolean {
    return this.disabledValances.includes(valance);
  }

  /**
   * Designer Trim (Single / Double / Triple) is incompatible with
   * alternating main canopy fabrics and alternating valance fabrics —
   * the trim runs as one continuous band and can't accommodate a
   * mid-panel fabric switch on either component. Double-vent
   * alternating IS allowed alongside trim.
   *
   * Bidirectional disable (mirrors Bullion5 ↔ French/Roman valance):
   *   - `isTrimRestrictedByAlternating` (true when main canopy OR
   *     valance has > 1 fabric) → disables Single / Double / Triple
   *     trim buttons; "No Trim" remains selectable.
   *   - The reciprocal "main canopy / valance add-fabric tile hidden
   *     while trim is active" is enforced in the template via
   *     `selectedTrimOption === 'none'` v-if guards on those tiles.
   */
  get isTrimRestrictedByAlternating(): boolean {
    const mainAlt =
      (this.item_details.canopy.mainFabric as FabricSwatch[]).length > 1;
    const valanceAlt =
      (this.item_details.canopy.valanceFabric as FabricSwatch[]).length > 1;
    return mainAlt || valanceAlt;
  }

  /**
   * True when the current user does NOT have the Admin role. Admins
   * are exempt from the stripe restrictions (they can mix striped
   * fabrics with designer trims and rectangle umbrellas for special
   * orders); everyone else is blocked.
   */
  get isNonAdmin(): boolean {
    return this.userRole !== Roles.Admin;
  }

  /**
   * True when the active umbrella's canopy shape is rectangular.
   * Rectangle canopies cannot use striped fabrics because the pattern
   * doesn't lay correctly across the asymmetric panels.
   */
  get isRectangleUmbrella(): boolean {
    return this.isRectangleShape(this.selected);
  }

  protected isRectangleShape(
    model: UmbrellaModel | null | undefined
  ): boolean {
    const shape = model?.shape;
    return (
      Array.isArray(shape) &&
      shape.length > 0 &&
      shape[0].toLowerCase() === "rectangle"
    );
  }

  /**
   * Detects whether any saved canopy-region fabric (main, vent top,
   * vent middle, valance) is striped. Trim and underside aren't
   * considered because they wouldn't be striped in the restricted state
   * to begin with.
   */
  protected isStripedFabric(swatch: FabricSwatch | null | undefined): boolean {
    return (
      !!swatch?.pattern_group && swatch.pattern_group.includes("Stripes")
    );
  }

  get hasStripedCanopyFabric(): boolean {
    const arrays: (FabricSwatch | null | undefined)[][] = [
      this.item_details.canopy.mainFabric as FabricSwatch[],
      this.item_details.canopy.ventTopFabric as FabricSwatch[],
      this.item_details.canopy.ventMiddleFabric as FabricSwatch[],
      this.item_details.canopy.valanceFabric as FabricSwatch[]
    ];
    for (const arr of arrays) {
      if (arr && arr.some(f => this.isStripedFabric(f))) return true;
    }
    return false;
  }

  /**
   * True when non-admin users should be prevented from enabling a
   * Designer Trim layout — happens when any saved canopy fabric is
   * striped or the umbrella is rectangular. Mirrors the alternating-
   * panel restriction.
   */
  get isTrimRestrictedByStripes(): boolean {
    return this.isNonAdmin && this.hasStripedCanopyFabric;
  }

  get isTrimRestrictedByShape(): boolean {
    return this.isNonAdmin && this.isRectangleUmbrella;
  }

  /**
   * Block non-admin users from switching to a rectangle umbrella model
   * while any saved canopy fabric is striped. Stripes don't lay
   * correctly on rectangle canopies; flipping the model would silently
   * create an invalid combination. The model picker disables matching
   * options with a tooltip explaining the conflict — the user has to
   * change the striped fabric first, or stay on the current shape.
   */
  protected isModelDisabledForStripes(model: UmbrellaModel): boolean {
    return (
      this.isNonAdmin &&
      this.isRectangleShape(model) &&
      this.hasStripedCanopyFabric
    );
  }

  protected isTrimOptionDisabled(
    trimValue: "none" | "single" | "double" | "triple"
  ): boolean {
    if (trimValue === "none") return false;
    return (
      this.isTrimRestrictedByAlternating ||
      this.isTrimRestrictedByStripes ||
      this.isTrimRestrictedByShape
    );
  }

  /**
   * `forceNoStripes` is passed to the FabricSelector when the active
   * picker should hide Stripes from the Design filter. True when the
   * user is non-admin AND (the canopy has a trim layout active OR the
   * umbrella is rectangular). Fringe / binding pickers are intentionally
   * skipped — those don't show Design at all.
   */
  protected isStripeRestrictedComponent(
    component: FabricComponent | null
  ): boolean {
    if (!component) return false;
    if (
      component === FabricComponent.Fringe ||
      component === FabricComponent.Binding ||
      component === FabricComponent.ChairBinding
    ) {
      return false;
    }
    return (
      this.isNonAdmin &&
      (this.selectedTrimOption !== "none" || this.isRectangleUmbrella)
    );
  }

  get forceNoStripesForActiveComponent(): boolean {
    return this.isStripeRestrictedComponent(this.component);
  }

  protected deleteValanceSwatch(index: number): void {
    this.item_details.canopy.valanceFabric.splice(index, 1);
    this.updatePriceAndSKU();
  }

  protected deleteFringeSwatch(index: number): void {
    this.item_details.canopy.fringeFabric.splice(index, 1);
    this.updatePriceAndSKU();
  }
}
